import { ArrowRight } from '../icons';
import ArrowIcon from '../icons/arrow-icon';
import { useEffect } from 'react';
import NextLink from '@/components/next-link';
const Title = ({
  title,
  isMulti = false,
  hasMore = false,
  hasArrows = true,
  titleColor = 'text-[#1A1A1A1]',
  multiData = [],
  active,
  setActive,
  swiper,
  isBeginning,
  isEnd,
  href = '#',
  hasMoreColor,
  locale,
  fromCategory = false,
  showArrows = true, // by default true and for pdp to shown when length is > 3
}) => {
  useEffect(() => {
    if (Object.keys(swiper || {}).length > 0) {
      swiper?.autoplay?.stop();
      setTimeout(() => {
        swiper?.autoplay?.start();
      }, 500);
    }
  }, [active, swiper]);
  return (
    <div className='relative flex items-center justify-between max-md:flex-wrap max-md:gap-3.5'>
      <h2
        className={`text-2xl font-semibold text-nowrap max-lg:text-xl max-md:text-lg max-sm:text-sm ${titleColor}`}
      >
        {title}
      </h2>
      {showArrows ? (
        <div className='flex items-center gap-5 max-sm:w-full'>
          {isMulti && (
            <div className='flex items-center gap-7.5 overflow-x-auto overflow-y-hidden'>
              {multiData?.map((info, index) => (
                <button
                  aria-label={info}
                  key={index}
                  onClick={() => setActive(index)}
                  className={`cursor-pointer pb-1 text-sm font-medium whitespace-nowrap text-[#858585] max-sm:text-xs ${active === index && 'max-sm:border-primary border-b border-[#68D237] text-[#E53E3E]'} `}
                >
                  {info?.[`title-${locale}`]}
                </button>
              ))}
            </div>
          )}

          {hasMore && (
            <NextLink
              href={href}
              className={`text-sm font-medium max-sm:absolute max-sm:end-2 max-sm:top-1/2 max-sm:-translate-y-[85%] max-sm:text-xs ${hasMoreColor || 'text-[#E53E3E]'}`}
            >
              {locale === 'en' ? 'See All' : 'عرض الكل'}
            </NextLink>
          )}
          {hasArrows && (
            <div
              className={`flex items-center justify-end max-sm:hidden rtl:flex-row-reverse ${fromCategory ? 'gap-2' : 'gap-6'}`}
            >
              {/* Previous Arrow */}
              <div
                onClick={() =>
                  locale === 'ar' ? swiper?.slideNext() : swiper?.slidePrev()
                }
                className={`flex cursor-pointer items-center justify-center rtl:rotate-180 ${
                  fromCategory &&
                  'rounded-full bg-[#F1F1F1] sm:size-5 md:size-6.5 lg:size-9'
                } ${
                  (locale === 'ar' && isEnd) || (locale === 'en' && isBeginning)
                    ? 'invisible'
                    : 'visible'
                }`}
              >
                {fromCategory ? (
                  <ArrowRight className='text-[#74787C] ltr:rotate-180' />
                ) : (
                  <ArrowIcon
                    className={`${locale === 'en' ? 'rotate-90' : '-rotate-90'} size-4 text-[#74787C]`}
                  />
                )}
              </div>

              {/* Next Arrow */}
              <div
                onClick={() =>
                  locale === 'ar' ? swiper?.slidePrev() : swiper?.slideNext()
                }
                className={`flex cursor-pointer items-center justify-center rtl:rotate-180 ${
                  fromCategory &&
                  'rounded-full bg-[#F1F1F1] sm:size-5 md:size-6.5 lg:size-9'
                } ${
                  (locale === 'ar' && isBeginning) || (locale === 'en' && isEnd)
                    ? 'invisible'
                    : 'visible'
                }`}
              >
                {fromCategory ? (
                  <ArrowRight className='text-[#74787C] rtl:rotate-180' />
                ) : (
                  <ArrowIcon
                    className={`${locale === 'en' ? '-rotate-90' : 'rotate-90'} size-4 text-[#74787C]`}
                  />
                )}
              </div>
            </div>
          )}
        </div>
      ) : null}
    </div>
  );
};

export default Title;
